// frontend/src/components/owner/ProtectedOwnerRoute.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export default function ProtectedOwnerRoute({ children }) {
  const loc = useLocation();
  let token = '';

  try {
    token = localStorage.getItem('ownerToken') || '';
  } catch {}

  if (!token) {
    return <Navigate to="/owner/login" replace state={{ from: loc }} />;
  }
  return children;
}
